/**
 * Paths relative to `REACT_APP_API_BASE_URL` (which should include `/v1`).
 * Example base: `http://135.13.28.178:8080/v1`
 */
export const apiRoutes = {
  admin: {
    organizations: "/admin/organizations",
    organizationsFilter: "/admin/organizations/filter",
    organizationsSearch: "/admin/organizations/search",
    organizationDetail: (organizationId: string) =>
      `/admin/organizations/${encodeURIComponent(organizationId)}`,
    organizationStatus: (organizationId: string) =>
      `/admin/organizations/${encodeURIComponent(organizationId)}/status`,
    /** Step 4 "Email Sent" checkbox — stamps welcome_email_sent_at and activates the org. */
    organizationWelcomeEmailSent: (organizationId: string) =>
      `/admin/organizations/${encodeURIComponent(organizationId)}/welcome-email-sent`,
    organizationDrafts: "/admin/organization-drafts",
    organizationDraftDetail: (draftId: string) =>
      `/admin/organization-drafts/${encodeURIComponent(draftId)}`,
    organizationsCreate: "/admin/organizations/create",
    organizationLogo: (organizationId: string) =>
      `/admin/organizations/${encodeURIComponent(organizationId)}/logo`,
    organizationVendorLogo: (organizationId: string, vendorId: string) =>
      `/admin/organizations/${encodeURIComponent(organizationId)}/vendors/${encodeURIComponent(vendorId)}/logo`,
    organizationWelcomeLink: (
      organizationId: string,
      organizationUserId: string,
    ) =>
      `/admin/organizations/${encodeURIComponent(organizationId)}/users/${encodeURIComponent(organizationUserId)}/welcome-link`,
    /** Proxies to wazuh_api's POST /groups — see ntpl-admin-onboarding-api app/api/v1/admin/wazuh.py. */
    organizationWazuhGroups: (organizationId: string) =>
      `/admin/organizations/${encodeURIComponent(organizationId)}/wazuh-groups`,
    /** Proxies to wazuh_api's GET /groups/{id}/install-commands — 404s if groups were
     * never provisioned for this org (e.g. Step 3's Wazuh call never succeeded). */
    organizationWazuhInstallCommands: (organizationId: string) =>
      `/admin/organizations/${encodeURIComponent(organizationId)}/wazuh-install-commands`,
    staffUsers: "/admin/staff/users",
    staffUsersSearch: "/admin/staff/users/search",
    staffUserDetail: (userId: string) =>
      `/admin/staff/users/${encodeURIComponent(userId)}`,
    reference: {
      industries: "/admin/reference/industries",
      countries: "/admin/reference/countries",
      securityTools: "/admin/reference/security-tools",
      cloudProviders: "/admin/reference/cloud-providers",
      complianceFrameworks: "/admin/reference/compliance-frameworks",
      standards: "/admin/reference/standards",
    },
    auth: {
      /** Password step → sends OTP email; sets login session cookie. */
      loginStart: "/admin/auth/login/start",
      /** OTP verification → returns access token. */
      loginVerify: "/admin/auth/login/verify",
      /** Resend OTP during login. */
      loginResend: "/admin/auth/login/resend",
      refresh: "/admin/auth/refresh",
      logout: "/admin/auth/logout",
      /** Current caller's profile — the only place the FE can learn its own role (admin vs super_admin). */
      me: "/admin/auth/me",
      passwordForgot: "/admin/auth/password/forgot",
      passwordReset: "/admin/auth/password/reset",
    },
  },
} as const;
